import React from "react";
import { Link } from "react-scroll";

function Carousal() {
  return (
    <>
      <div className="sticky top-0 z-30 px-5 mt-6 backdrop-blur-md">
        <ul className="text-base-muted font-sans font-semibold text-xl flex space-x-10 [&>*]:py-2 [&>*]:px-1 [&>*]:cursor-pointer scroll overflow-x-scroll scroll-smooth scrollbar-hide">
          <li className="nav-items ">
            <Link
              to="burger"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              Burgers
            </Link>
          </li>
          <li className="nav-items">
            <Link
              to="pizza"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              Pizza
            </Link>
          </li>
          <li className="nav-items">
            <Link
              to="rolls"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              Rolls
            </Link>
          </li>
          <li className="nav-items">
            <Link
              to="fryers"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              {" "}
              Fryers
            </Link>
          </li>
          <li className="nav-items">
            <Link
              to="sandwiches"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              {" "}
              Sandwiches
            </Link>
          </li>
          <li className="nav-items">
            <Link
              to="drinks"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              {" "}
              Drinks
            </Link>
          </li>
          <li className="nav-items">
            <Link
              to="deals"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              {" "}
              Deals
            </Link>
          </li>
          <li className="nav-items">
            <Link
              to="delivery"
              spy={true}
              smooth={true}
              offset={-50}
              duration={300}
            >
              Delivery
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Carousal;
